import axios from "axios";
import * as PATH from "../helpers/APIURL";

export default class RestaurantOwnerService {

    static getRestaurantOwnerList = params => {
        return axios.get(PATH.GET_ALL_RESTAURANT_OWNER, {params});
    }

}
